import { createApiClient } from '../../api';

import { ACCESS_ENDPOINTS } from './endpoints';
import { errorFrom } from './http';
import { parseMe } from './schemas';
import type { MePayload } from './schemas';

const { request } = createApiClient({ toError: errorFrom });

const ME_TIMEOUT_MS = 8_000;

export const fetchMePayload = async (signal?: AbortSignal): Promise<MePayload> =>
  parseMe(await request('get', ACCESS_ENDPOINTS.ME, { signal, timeoutMs: ME_TIMEOUT_MS }));
